export default "__VITE_ASSET__872e1632__"